
import { mapState } from 'vuex'
import _ from 'lodash'
import LastSeen from '../components/home/LastSeen'
import SimpleSearchProductElement from '../components/product/single'
import PaginationCommon from '../components/element-ui/Pagination'
import ListFilter from '../components/element-ui/ListFilter'
import SortCategory from '../components/element-ui/filter/SortCategory'
import {
  SET_REMOVE_FILTER,
  SET_CLEAR_ALL_FILTER,
  PRODUCT_SEARCH,
  CATEGORY_SEARCH, SET_ADD_FILTER, INDEX_SET_LOADING, INDEX_SET_HIDE_FOOTER
} from '../store/store.const'
import { removeVietnameseTones, textToSlug } from '../utils/utils'

export default {
  name: 'SearchCommon',
  components: { ListFilter, LastSeen, PaginationCommon, SimpleSearchProductElement, SortCategory },
  data() {
    const PRODUCT_DEFAULT = []
    return {
      keyword: this.$route.query.search || '',
      products: _.cloneDeep(PRODUCT_DEFAULT),
      productDefault: PRODUCT_DEFAULT,
      listFilter: [
        'category_search',
        'price',
        'price_range',
        'branch',
        'rating'
      ],
      listDataFilter: {},
      listFilterAdvance: [],
      listDataFilterAdvance: {},
      total: 123,
      page: 1,
      lastPage: 1,
      perPage: 24,
      typeSort: 5,
      listSort: [
        {
          text: 'involve',
          value: 5,
          label: this.$t('sort.involve')
        },
        {
          text: 'popular',
          value: 6,
          label: this.$t('sort.popular')
        },
        {
          text: 'new',
          value: 1,
          label: this.$t('sort.new')
        },
        {
          text: 'hot_sale',
          value: 2,
          label: this.$t('sort.hot_sale')
        },
        {
          text: 'sort_desc',
          value: 3,
          label: this.$t('sort.sort_desc')
        },
        {
          text: 'sort_asc',
          value: 4,
          label: this.$t('sort.sort_asc')
        }
      ],
      dataFilter: [],
      showModalCategory: false,
      hideModalCategory: false,
      checkLoad: false,
      nextPage: true
    }
  },
  async fetch() {
    await this.getProductData()
    await this.getCategoryData()
  },
  computed: {
    ...mapState('filter', {
      clearAllFilter: state => state.clearAllFilter,
      addFilter: state => state.addFilter
    }),
    paramUrl() {
      let query = ''
      const filter = []
      filter.push(`search=${this.keyword}`)
      this.dataFilter.forEach(data => {
        filter.push(`${data.type}=${data.list.join(',')}`)
      })
      if (this.typeSort) {
        filter.push(`order_by=${this.typeSort}`)
      }
      if (this.page > 1) {
        filter.push(`page=${this.page}`)
      }
      query = filter.join('&')

      return query
    },
    dataSearch() {
      const search = {
        search: this.keyword || '',
        page: this.page,
        per_page: this.perPage
      }
      this.dataFilter.forEach(data => {
        search[data.type] = data.list.join(',')
      })
      if (this.typeSort) {
        search.order_by = this.typeSort
      }
      return search
    },
    hideFooter() {
      return this.$store.state.hideFooter
    }
  },
  watch: {
    '$route.query.search'(val) {
      this.keyword = val
      this.getProductData({
        search: this.keyword
      })
    },
    async typeSort() {
      history.pushState({}, null, '/search?' + this.paramUrl)
      await this.getProductData()
    }
  },
  async mounted() {
    await this.getCategoryData()
    this.convertDataUrl()
    window.onscroll = async() => {
      const bottomOfWindow = document.documentElement.offsetHeight - (document.documentElement.scrollTop + window.innerHeight) < 100
      if (bottomOfWindow && this.hideFooter && this.$device.isMobile && this.nextPage) {
        this.nextPage = false
        this.page++
        await this.getProductData()
        this.nextPage = true
      }
    }
    document.title = this.$t('search.result', { search: this.keyword }) + ' - ' + this.$t('home.title')
  },
  methods: {
    async changeDataFilter(value) {
      const data = []
      let check = true
      this.dataFilter.forEach(filter => {
        if (filter.type === value.type) {
          if (value.value.length > 0) {
            data.push(value)
          }
          check = false
        } else {
          data.push(filter)
        }
      })
      if (check) data.push(value)
      this.dataFilter = data
      history.pushState({}, null, '/search?' + this.paramUrl)
      await this.getProductData()
    },
    removeFilter(type, data) {
      this.$store.commit(SET_REMOVE_FILTER, { type, value: data })
    },
    clearFilter() {
      this.$store.commit(SET_CLEAR_ALL_FILTER, !this.clearAllFilter)
    },
    changeToLink(link) {
      this.$router.push(link)
    },
    async changePaginate(page) {
      this.page = page; history.pushState({}, null, '/search?' + this.paramUrl)
      await this.getProductData()
    },
    async getProductData() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)

        const products = await this.$store.dispatch(PRODUCT_SEARCH, this.dataSearch)

        if (!this.$device.isMobile) {
          this.products = products.data.data
          this.page = products.data.current_page
          this.lastPage = products.data.total_page
          this.total = products.data.total
        } else {
          this.products = this.products.concat(products.data.data)
          this.page = products.data.data.length ? products.data.current_page : (this.page - 1)
          this.lastPage = products.data.total_page
          this.total = products.data.total
          this.$store.commit(INDEX_SET_HIDE_FOOTER, products.data.data.length > 0)
        }
      } catch (e) {
        console.log(e)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    async getCategoryData() {
      try {
        const category = await this.$store.dispatch(CATEGORY_SEARCH, { search: this.keyword })
        this.category = this.convertDataCategory(category.data)
      } catch (e) {
        console.log(e)
      }
    },
    convertDataUrl() {
      const query = this.$route.query
      for (const [key] of Object.entries(query)) {
        if (key === 'order_by') {
          this.typeSort = Number(query[key])
        }
        if (key === 'page') {
          this.page = Number(query[key])
        }
      }
      this.$store.commit(SET_ADD_FILTER, !this.addFilter)
    },
    convertDataCategory(category) {
      const categories = []
      category.categories.forEach(cat => {
        categories.push({
          id: cat.id,
          name: cat.name,
          link: '/category/' + textToSlug(removeVietnameseTones(cat.name)) + '.' + cat.id,
          image: cat.image_url,
          image_thumb_url: cat.image_thumb_url
        })
      })
      this.listDataFilter.category_search = categories
      this.listDataFilter.branch = category.shops.map(shop => {
        return { ...shop, value: shop.name }
      })
      this.listDataFilter.price = category.price_range
      category.properties.forEach(property => {
        this.listDataFilterAdvance[property.key] = property
        this.listFilterAdvance.push(property.key)
      })
      this.checkLoad = !this.checkLoad
    },
    async changePage(page) {
      const search = {
        search: this.keyword || '',
        page,
        per_page: this.perPage
      }
      this.dataFilter.forEach(data => {
        search[data.type] = data.list.join(',')
      })
      if (this.type_sort) {
        search.order_by = this.type_sort
      }
      await this.$emit('change', search)
    },
    closeModalCategory() {
      this.showModalCategory = false
    }
  }
}
